import { gql, useQuery } from '@apollo/client';
import { Exception } from '@livecontrol/core-ui';
import { Obj } from '@livecontrol/core-utils';
import { Account } from '@livecontrol/scheduler/model';
import { useEffect, useState } from 'react';
import type { QueryResult } from '../graphql';
import * as Dbx from './dbx';

interface TVariables {
  id: number;
}

interface TData {
  getSubUsersForAccount?: {
    result?: Dbx.SubUserAccountsRecord[];
  };
}

export const QUERY = gql`
  query GetSubUsersForAccount($id: Float!) {
    getSubUsersForAccount(accountId: $id) {
      id
      success
      result {
        ...StandardSubUserAccountsResponse
      }
    }
  }
  ${Dbx.StandardSubUserAccountsResponse}
`;

export const useSubUsersAccount = (args: Account.Like): QueryResult<Account.SubUser[], 'subUsers'> => {
  const [error, setError] = useState<Error | undefined>();
  const [subUsers, setSubUsers] = useState<Account.SubUser[] | undefined>();

  const variables = {
    id: Account.toId(args)
  };

  if (!Obj.isHydrated(variables)) {
    return { loading: false, error: Exception.KABOOM };
  }

  /* eslint-disable react-hooks/rules-of-hooks */

  const { loading, data } = useQuery<TData, TVariables>(QUERY, {
    variables,
    onError() {
      setError(Exception.KABOOM);
    }
  });

  useEffect(() => {
    let subUsers_;
    let error_;

    if (data) {
      subUsers_ = Dbx.SubUser.normalize(data.getSubUsersForAccount?.result);
    }

    setSubUsers(subUsers_);
    setError(error_);
  }, [data]);

  return { loading, error, subUsers };
};
